import { render } from "./Toggle1.vue?vue&type=template&id=83b1f3ae"
import script from "./Toggle1.vue?vue&type=script&lang=js"
export * from "./Toggle1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__